import { extractShipmentNumber } from '../utils/shipmentHelpers';

export interface Suggestion {
  label: string;
  query: string;
}

export interface RouteRule {
  pattern: string;
  exact?: boolean;
  generator: (params: Record<string, string | undefined>, search: string, pathname: string) => Suggestion[];
}

export const ROUTE_SUGGESTIONS_MAP: RouteRule[] = [
  {
    pattern: '/',
    exact: true,
    generator: () => [
      { label: 'Total Placed Shipments', query: 'Show total placed shipments' },
      { label: 'Cancelled Shipments', query: 'Show cancelled shipments' },
      { label: 'Total Weight', query: 'Show total weight' },
      { label: 'Revenue', query: 'Show revenue' },
    ],
  },
  {
    pattern: '/get-rates',
    exact: true,
    generator: () => [{ label: 'Get rates for 5 KG shipment', query: 'Get rates for 5 KG shipment' }],
  },
  {
    pattern: '/profile',
    exact: true,
    generator: (_params, search) => {
      const searchParams = new URLSearchParams(search);
      if (searchParams.get('tab') === 'change_password') {
        return [{ label: 'Change Password', query: 'I want to change my password' }];
      }
      return [];
    },
  },
  {
    pattern: '/user',
    exact: true,
    generator: () => [{ label: 'KYC Pending', query: 'Show pending KYC user list' }],
  },
  {
    pattern: '/admin',
    exact: true,
    generator: () => [{ label: 'KYC Pending', query: 'Show pending KYC admin tasks' }],
  },
  {
    pattern: '/shipment/history',
    exact: true,
    generator: () => [
      { label: 'Download Shipment Reports', query: 'Download shipment reports' },
      { label: 'Repeat Shipment', query: 'Repeat previous shipment' },
      { label: 'Download Label', query: 'Download shipment label' },
    ],
  },
  {
    pattern: '/shipment/admin/edit/:shipmentNumber',
    exact: true,
    generator: (_params, _search, pathname) => {
      const num = extractShipmentNumber(pathname);
      return [
        // { label: 'Shipment Status', query: `What is the status of shipment ${num}?` },
        { label: 'Track Shipment', query: `Track shipment ${num}` },
        { label: 'Repeat Shipment', query: `Repeat shipment ${num}` },
        { label: 'Update Shipment', query: `Update shipment ${num}` },
        { label: 'Download Carrier AWB', query: `Download Carrier AWB for ${num}` },
        { label: 'Add Charges', query: `Add charges to shipment ${num}` },
        { label: 'Update Shipment Status', query: `Update status of shipment ${num}` },
      ];
    },
  },
  {
    pattern: '/shipment/history/:shipmentNumber',
    exact: true,
    generator: (_params, _search, pathname) => {
      const num = extractShipmentNumber(pathname);
      return [
        { label: 'Shipment Status', query: `What is the status of shipment ${num}?` },
        { label: 'Repeat Shipment', query: `Repeat shipment ${num}` },
        { label: 'Update Shipment', query: `Update shipment ${num}` },
        { label: 'Download Carrier AWB', query: `Download Carrier AWB for ${num}` },
        { label: 'Add Charges', query: `Add charges to shipment ${num}` },
        { label: 'Update Shipment Status', query: `Update status of shipment ${num}` },
      ];
    },
  },
  {
    pattern: '/invoice/view',
    exact: true,
    generator: () => [
      { label: 'Create Invoice', query: 'Create new invoice' },
      { label: 'Download Report', query: 'Download invoice report' },
    ],
  },
  {
    pattern: '/transactions/list',
    exact: true,
    generator: () => [{ label: 'Download Report', query: 'Download transaction list report' }],
  },
  {
    pattern: '/transactions/credits-and-wallets',
    exact: true,
    generator: () => [{ label: 'Download Report', query: 'Download credits and wallets report' }],
  },
  {
    pattern: '/purchase-invoices',
    exact: true,
    generator: () => [
      { label: 'Create Purchase Invoice', query: 'Create new purchase invoice' },
      { label: 'Download Report', query: 'Download purchase invoice report' },
    ],
  },
  {
    pattern: '/purchase-invoices/credits-transaction',
    exact: true,
    generator: () => [{ label: 'Download Report', query: 'Download purchase invoice credits transaction report' }],
  },
];
